import http from '../helpers/http';

export default class SupervisorRepository {

    getDivisions(lastDownloadedDate) {
        return http.post('/api/v1/supervisor/divisions', {
            divisionsLastDownloaded: lastDownloadedDate
        })
    }

    getData(serialNumber, divisionID, supervisorDataLastDownloaded) {
        return http.post('/api/v1/supervisor/data', {
            serialNumber,
            divisionID,
            supervisorDataLastDownloaded
        }).then(data => {
            data.lastFetched = new Date();
            return data;
        });
    }

    getDivisionLocations(serialNumber, divisionID) {
        return http.post('/api/v1/supervisor/locations', {
            serialNumber,
            divisionID
        });
    }

    getCompetences(serialNumber, divisionID, projectID, siteID, siteCode, zoneID, zoneCode) {
        return http.post('/api/v1/supervisor/competences', {
            serialNumber,
            divisionID,
            projectID,
            siteID,
            siteCode,
            zoneID,
            zoneCode
        });
    }

    getAwardableCompetences(serialNumber, divisionID, projectID, siteID, siteCode, zoneID, zoneCode, categoryID) {
        return http.post('/api/v1/supervisor/awardableCompetences', {
            serialNumber,
            divisionID,
            projectID,
            siteID,
            siteCode,
            zoneID,
            zoneCode,
            categoryID
        });
    }
}